// eslint-disable-next-line jira/wrm/no-load-bridge
import { loadBridge, waitForHeritage } from '@atlassian/jira-common-bridge/src';
import { waitForJQuery } from './common/index.tsx';
import type { ACJSHost } from './types.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { ACJSHost };
const installConnectJs = async () => {
	// we need the heritage to load in order for WRM core and jQuery to exist.
	// eslint-disable-next-line jira/wrm/no-load-bridge
	await waitForHeritage();
	await waitForJQuery();

	const loader = await import(/* webpackChunkName: "async-connect-js-api" */ './loader');
	await loader.performSideEffects();

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	return window.connectHost;
};

let installConnectJsPromise: Promise<ACJSHost> | null = null;

export const setupConnectJs = async (): Promise<ACJSHost> => {
	// Only pages in the SPA will benefit from modernising connect

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	if (window.__SPA__) {
		if (installConnectJsPromise === null) {
			installConnectJsPromise = installConnectJs();
		}

		return installConnectJsPromise;
	}
	// eslint-disable-next-line jira/wrm/no-load-bridge
	await loadBridge({
		name: 'ac/create',
		wrmKeys: [
			'wrc!com.atlassian.plugins.atlassian-connect-plugin:jira-atlassian-connect-resources-v5',
			// Undeclared Dependency: jira/navigation
			'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar',
		],
	});

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	return window.connectHost;
};
